
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import upload from '../assets/images/upload.png'
import http from '../services/httpService'
import config from '../config.json'
import axios from 'axios'
import { useNavigate, useParams } from "react-router-dom";
import SideNav from '../components/sideNav'
import SideNavContent from '../components/sideNavContent'
import routes from "../components/routes";
import { Ptag, LargeButton, Icons } from '../components/core'
import * as Yup from "yup";


const UploadRatechart = () => {
    const [rateChartName, setUploadRateChart] = useState()
    const [rateChartError, setrateChartError] = useState()
    const [is_click,setIsClick] = useState(false)
    const [isShown, setIsShown] = useState(false)
    const userplan_id = localStorage.getItem('userplan_id') || sessionStorage.getItem('userplan_id') || ''
    const policy_type=localStorage.getItem('business_type')
    const dependent_type = localStorage.getItem('dependent_type')
    const [initialValues, setInitialValues] = useState({})
    const {type} = useParams()
    
    const handleUploadDocument = () => {
      document.getElementById("idShown").value === 'Custom' ? setIsShown(true): setIsShown(false)
    }

    const handleDefault = event => {
      // setInitialValues({
      //   policyDoc:'',    
      // })
      setIsShown(false)
    }

    const renderError = (error, style) => {
       
        return (
          <Error style={style}>
            {error}
          </Error>
        )
    }

    const getInitialValues = async  () => {(
      setInitialValues({
        policyDoc: '',
        
      })
    )}

    useEffect(() => {
      getInitialValues()
    },[])

    const showSidebar = () => {
        return !!localStorage.getItem('userplan_id')
      }

    let navigate =  useNavigate();

    const savePlanIdAndNavigate = (response) => {
      if(type === 'onboarding'){
        response && response['userplan_id'] && sessionStorage.setItem('userplan_id',response['userplan_id'])
        navigate(`/${routes.UPLOAD_EXCEL}/onboarding`);
      } else {
        window.history.pushState(null, null, '/')
        response && response['userplan_id']&& localStorage.setItem('userplan_id', response['userplan_id'])
        if(response['employee_reupload']){
          navigate(`/${routes.UPLOAD_EXCEL}/edit`);
        } else {
          navigate(`/${routes.CARE_DASHBOARD}`);
        }
      }
    }
    
    const  onUploadRatechart= async (oEvent, formikProps, name) => {
      if (!oEvent?.target?.files[0]) {
          return
      }
      
      let formData = new FormData()
      formData.append('file_details', oEvent.target.files[0])
      try {
            formData.append('file_owner',localStorage.getItem('id'))
            formData.append('file_type', 'premiums_excel')
            const { data } = await axios({

                url: config.apiUrl + '/insurance/upload_document/',
                method: 'POST',
                data: formData,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                }
            })
            data.id && localStorage.setItem('document_id',data.id)
            setUploadRateChart(oEvent.target.files[0]['name'])
     } catch (ex) {
        oEvent.target.value = null
        if(ex.response && Array.isArray(ex.response.data)){
          console.log(Array.isArray(ex.response.data))
        }
     }

     let rateChartData = new FormData()
  
      try {
              rateChartData.append('document_id',localStorage.getItem('document_id'))
              rateChartData.append('policy_type',policy_type)
              rateChartData.append('user_plan_id',userplan_id)
              rateChartData.append('dependent_type',dependent_type)
              const { data } = await axios({
  
                  url: config.apiUrl + '/insurance/setup_gmc_premiums/',
                  method: 'POST',
                  data: rateChartData,
                  headers: {
                      Accept: 'application/json',
                      'Content-Type': 'multipart/form-data',
                  }
              })
              localStorage.setItem('premium_id', data.premium_id)
              console.log(data.premium_id)
          
      } catch (ex) {
          oEvent.target.value = null
          if(ex.response && Array.isArray(ex.response.data)){
            console.log(Array.isArray(ex.response.data))
          }
      }
    }
    


    const renderUploadRatechart = () => {
        return (
          <UploadWrapper>
             <UploadButton id="business_ratechart_upload_button" onClick={() => document.getElementById('fileSelect2').click()} >
                <img style={{ 'marginRight': '10px' }} src={upload} height='20px' width='17px' />
                <input
                    name='upload'
                    id="fileSelect2"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange = {(oEvent) => onUploadRatechart(oEvent)}
                />
                <Ptag fontSize='14px' fontWeight='600' letterSpacing='0.44px' letterHeight='19px'>
                    {'Upload Rate Chart'}
                </Ptag>
                
            </UploadButton>
            {!rateChartName && renderError(rateChartError,{position: 'inherit', marginTop: '1.2rem'})}
            <Ptag>
              {
                rateChartName
              }
            </Ptag>
            </UploadWrapper>
         
        )
    }

      const renderForm = () => {
          
        return (
                <HomeWrapper>
                  <Ptag
                    fontSize="24px"
                    fontWeight="600"
                    letterHeight="1.33"
                    letterSpacing="0.35px"
                    style={{'padding-bottom':'40px'}}
                  >
                    {"Build your plan"}
                  </Ptag>
                  <Heading>
                  <Ratetag>
                    <Leftrow>
                    <Ptag fontSize='19px' fontWeight='500' letterSpacing='0.44px' letterHeight='19px' width='170px' style={{'textAlign': ''}}>
                        Rate Chart
                    </Ptag>
                    </Leftrow>
                    <DropdownWrapper>
                          <AgeWrapper id='idShown' onChange={handleUploadDocument}>
                            <option value='Default'>Default</option>
                            <option value='Custom'>Custom</option>
                          </AgeWrapper>
                          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%', 'paddingright': '3px' }} icon='chevron_down' fill="#7e7b7f" />
                    </DropdownWrapper>
                  </Ratetag>
                  </Heading>
                  {console.log(isShown)}
                {isShown && renderUploadRatechart()}
                {/* {renderUploadPolicyDoc()} */}
                <ButtonWrapper>
                    <LargeButton
                    // disabled={isDisabled}
                    // opacity={isDisabled ? "0.4" : "1"}
                    id="business_about_next12"
                    label={" SAVE & NEXT"}
                    type="submit"
                    onClick={(isShown) => handleSubmit(isShown)}
                    />
                </ButtonWrapper>
                </HomeWrapper>
        );
      };

      const handleSubmit = async () => {
        if(is_click==true){
          return
        }
        console.log(isShown)

        if(isShown && !rateChartName){
          setrateChartError("*Please upload ratechart")
          return
        }


        setIsClick(true)
      
        let sum_insured_gpa = localStorage.getItem('sum_insured_gpa')
        sum_insured_gpa = Number(sum_insured_gpa)
        sum_insured_gpa = sum_insured_gpa <= 0 ? 0 : (sum_insured_gpa || 0)
        try {
          let resp =await http.post("/business/setupplan/", {
            business_user_id:localStorage.getItem('id'),
            policy: localStorage.getItem('policy'),
            business_type:localStorage.getItem('business_type'),
            benefit_type:localStorage.getItem('benefit_type'),
            discount_type:localStorage.getItem('discount_type'),
            dependent_type:localStorage.getItem('dependent_type'),
            rewards:localStorage.getItem('rewards'),
            insurer_name: 'go_digit',
            // document_id: localStorage.getItem('document_id'),
            sum_insured_gpa,
            sum_insured: localStorage.getItem('sum_insured'),
            premium_id : localStorage.getItem('premium_id') || null
            
          });
          localStorage.removeItem('source')
          localStorage.removeItem('company_name')
          localStorage.removeItem('city')
          localStorage.removeItem('pincode')
          localStorage.removeItem('gstno')
          localStorage.removeItem('primary_contact_name')
          localStorage.removeItem('primary_contact_email')
          localStorage.removeItem('primary_contact_mobile')
          localStorage.removeItem('phone')
          localStorage.removeItem('secondary_contact_name')
          localStorage.removeItem('secondary_contact_email')
          localStorage.removeItem('secondary_contact_mobile')
          localStorage.removeItem('premium_id')
          localStorage.removeItem('document_id')
          savePlanIdAndNavigate(resp.data)
    
        } catch (ex) {
        //  await  this.setState({ loading: false });
          const error = ex.response && ex.response.data;
          
          console.error(ex);
        }
        setIsClick(false)
        // await this.setState({
        //   is_click:false,
        // })
      };


      let Schema
      Schema = Yup.object().shape({
        policyDoc: Yup.object().required("*Please upload policy document"),
        rateChart: Yup.object().required("*Please upload rate chart")
      });


    return (
        <>
            <SideNav>
                {
                    showSidebar() && 
                    <SideNavContent />
                }
                
            </SideNav>

            <Root>
                    {
                    // // loading ? <OverlayLoader /> :
                    //     <Formik 
                    //       enableReinitialize={true}
                    //       initialValues={initialValues}           
                    //       validationSchema={Schema}
                    //       onSubmit={handleSubmit}
                    //       render = {(formikProps) => renderForm(formikProps)}
                    //     />
                  
                    }

                    {renderForm()}
            </Root>
        </>
    )
}
const Body = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 1;
`

const Leftrow=styled.div`
  min-width: 30%;
  text-align: center;
  padding-top:15px ;
`
const AgeWrapper = styled.select`
    display: flex;
    width: 100%;
    border: none;
    font-family: "Inter";
    font-size: 15px;
    font-weight: 200;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.25px;
    background-color: transparent;
    -webkit-appearance: none;
    &:hover,
    &:focus 
    {
      outline: 0 !important;
    };
`;

const UploadButton = styled.div`
    display: flex;
    margin-top: 24px;
    border: 1px dashed #436AB2;
    border-radius: 10px;
    padding: 48px;
    justify-content: center;
    cursor: pointer;
    & > input{
        display: none;
    }  
`

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

const HomeWrapper = styled.div`
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  background:#fff;
  height:100vh;
  margin-left: 200px;
`

const Heading = styled.div`
  padding-bottom: 20px;
  /* width:100%;
  text-align: left;
  padding-bottom: 10px;
  border-bottom: 1px solid #979797;
  /* border-bottom: 1px solid #979797;
  margin-top: 20px; */
  margin-bottom: 40px; 
`
const UploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  margin-top:60px;
`;

const Option = styled.option`
 color: ${props => props.color ? props.color : 'black'};
`

const Formtag = styled.div`
    BORDER: 1px solid;
    COLOR: #436ab2;
    display :flex;
    flex-direction: row;
    justify-content: right;
    height: 30px; 
    width: 100%;
    min-width: 60%;
    border-radius: 4px;
    align-items: center;
    /* margin-left: 50px; */
`

const Ratetag= styled.div`
    display: flex;
    flex-direction: row;
    height: 30px;
`
const DropdownComponentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 30px;
`
const DropdownWrapper = styled.div`
    display: flex;
    padding-left: 13px;
    padding-right: 13px;
    align-items: center;
    BORDER: 1.4px solid;
    COLOR: #436ab2;
    display :flex;
    flex-direction: row;
    justify-content: right;
    height: 50px; 
    width: 100%;
    min-width: 60%;
    border-radius: 4px;
    align-items: center;
`
const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`

const InputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;



export default UploadRatechart